


















































































import { faEraser, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons'
import LeasingOptionsFormHandlerRow from '~/components/car/classifieds/form/fieldsets/fields/handlers/leasing/LeasingOptionsFormHandlerRow.vue'
import { computed, defineComponent, ref } from '@nuxtjs/composition-api'
import LeasingService from '~/services/classified/finance/LeasingService'
import { Ref } from '@vue/composition-api'
import { useClassifiedForm } from '~/compositions/form'
import { formFieldProps } from '~/constants/form'
import { useDep } from '~/compositions/dependency-container'
import { useI18n } from '~/compositions/i18n'

export default defineComponent({
  props: formFieldProps,
  components: {
    LeasingOptionsFormHandlerRow
  },
  setup(props) {
    const { specs, name } = props

    const { t } = useI18n()
    const leasingService = useDep(LeasingService)

    const optionsRows = ref<any>([])
    const notOriginalOfferTypeError = ref(null)
    const optionsError = ref(null)

    const icons = {
      delete: faTrash,
      plus: faPlus,
      clear: faEraser
    }

    function getEmptyRow() {
      return {
        duration: null,
        mileage: null,
        downpayment: null,
        lease: null,
        purchase_price: null
      }
    }

    function onValue(v: Ref<any>) {
      if (v.value?.options.length > 0) {
        optionsRows.value = v.value.options
      } else {
        optionsRows.value = [getEmptyRow()]
      }
    }
    function onError(e: Ref<any>) {
      if (e.value) {
        notOriginalOfferTypeError.value = e.value.not_original_offertype
        optionsError.value = e.value.options
      }
    }

    const { valueChanged } = useClassifiedForm(props, { onError, onValue })

    const maxNumberOfOptionsRows = computed(() => specs.max_rows)
    const moreRowsCanBeAdded = computed(
      () => optionsRows.value.length < maxNumberOfOptionsRows.value
    )
    const lastRowIsNotFilled = computed(() =>
      leasingService.formOptionIsEmpty(
        optionsRows.value[optionsRows.value.length - 1]
      )
    )
    const addOptionButtonTooltipText = computed(() =>
      lastRowIsNotFilled.value
        ? t('please fill the previous option to add more options')
        : ''
    )
    const moreThanOneRowExists = computed(() => optionsRows.value.length > 1)
    const rowCols = computed(() => {
      if (moreThanOneRowExists.value) {
        return {
          cols: 12,
          md: 11
        }
      }
      return { cols: 12, md: 12 }
    })
    const pricesWithoutVatMessage = computed(
      () =>
        `* ${t('the prices listed above do not include')} ${t('vat')
          .toString()
          .toUpperCase()} (24%)`
    )
    const createRow = () => {
      optionsRows.value.push(Object.assign({}, getEmptyRow()))
    }
    const optionsChanged = (options: any[]) => {
      const opts = options.filter(o => !leasingService.formOptionIsEmpty(o))
      valueChanged(name, {
        options: opts
      })
    }
    const handleOptionChange = (index, name, value) => {
      optionsRows.value[index][name] = value

      optionsChanged(optionsRows.value)
    }
    const deleteRow = (index: number) => {
      optionsRows.value.splice(index, 1)
      optionsChanged(optionsRows.value)
    }
    const deleteAllRows = () => {
      optionsRows.value = [getEmptyRow()]
      optionsChanged([])
    }

    return {
      icons,
      moreRowsCanBeAdded,
      lastRowIsNotFilled,
      addOptionButtonTooltipText,
      notOriginalOfferTypeError,
      optionsError,
      optionsRows,
      moreThanOneRowExists,
      rowCols,
      pricesWithoutVatMessage,
      createRow,
      deleteAllRows,
      deleteRow,
      handleOptionChange
    }
  }
})
